<template>
  <div class="dev-warning-banner" style="position: sticky; top: 0; z-index: 9999; width: 100%; height: 48px;">
      Ambiente de desarrollo no productivo
  </div>
</template>


<script>
export default {
  name: 'DevEnvAlert',
}
</script>
<style lang="scss">
.dev-warning-banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 48px;
  background: #FFE3E2;          
  color: #C41C30;               
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  font-size: 1rem;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.04);
  font-family: $rc-font-sf;
}
</style>